import TextButton from 'LuxKit/Button/TextButton'
import BestPricesIcon from 'LuxKit/Icons/custom/BestPricesIcon'
import BinocularsIcon from 'LuxKit/Icons/custom/BinocularsIcon'
import BookingIcon from 'LuxKit/Icons/custom/BookingIcon'
import BuyNowBookLaterIcon from 'LuxKit/Icons/custom/BuyNowBookLaterIcon'
import ExclusiveAccessIcon from 'LuxKit/Icons/custom/ExclusiveAccessIcon'
import FlexibleBookingsIcon from 'LuxKit/Icons/custom/FlexibleBookingsIcon'
import HandpickedPartnersIcon from 'LuxKit/Icons/custom/HandpickedPartnersIcon'
import HotelIcon from 'LuxKit/Icons/custom/HotelIcon'
import RefundIcon from 'LuxKit/Icons/custom/RefundIcon'
import SevenDaysIcon from 'LuxKit/Icons/custom/SevenDaysIcon'
import VipInclusionsIcon from 'LuxKit/Icons/custom/VipInclusionsIcon'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import LineCheckCircleIcon from 'LuxKit/Icons/line/LineCheckCircleIcon'
import LineMapIcon from 'LuxKit/Icons/line/LineMapIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import SvgIcon from 'LuxKit/SvgIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const Container = styled(Group)`
  max-width: ${rem(208)};
`

const howItWorksIcons: Record<string, typeof SvgIcon> = {
  '7-days': SevenDaysIcon,
  'quality-guaranteed': LineCheckCircleIcon,
  'best-prices': BestPricesIcon,
  'vip-inclusions': VipInclusionsIcon,
  hotel: HotelIcon,
  'flexible-bookings': FlexibleBookingsIcon,
  'handpicked-partner': HandpickedPartnersIcon,
  refund: RefundIcon,
  map: LineMapIcon,
  binoculars: BinocularsIcon,
  tickets: LineTicketIcon,
  'exclusive-access': ExclusiveAccessIcon,
  booking: BookingIcon,
  'buy-now-book-later': BuyNowBookLaterIcon,
  calendarIcon: LineCalendarIcon,
}

interface Props {
  item: any
  className?: string
  hideContent?: boolean
}

function HowItWorksItem(props: Props) {
  const { item, className, hideContent } = props
  const {
    icon,
    iconSize,
    title,
    content,
    contentSize = 'medium',
    iconType = 'primary',
    light,
    slug,
  } = item

  const Icon = howItWorksIcons[icon]

  return <Container direction="vertical" horizontalAlign="center" gap={16} className={className}>
    {!!Icon && <Icon size={iconSize} colour={iconType} />}
    <Group direction="vertical" horizontalAlign="center" gap={8}>
      <Heading variant="heading6" colour={light ? 'neutral-eight' : undefined} align="center">
        {title}
      </Heading>
      {!hideContent && content && <BodyText
        variant={contentSize}
        colour={light ? 'neutral-eight' : undefined}
        align="center"
      >
        {content}
      </BodyText>}
    </Group>
    {!!slug && <TextButton kind="tertiary" to={`/${slug}`}>Find out more</TextButton>}
  </Container>
}

export default HowItWorksItem
